import qs from 'qs';
import { useQuery } from 'react-query';

import { axios } from 'lib';

const getDirectsCount = (expired) => {
  const queryString = qs.stringify({ expired });
  return axios.get(
    `/api/directs/count?${queryString}`
  );
};

export const useDirectsCount = (expired = false, options = {}) => {
  return useQuery(
    `directs-expired-${expired}-count`,
    () => getDirectsCount(expired),
    {
      //@ts-ignore
      initialData: { data: { count: 0 } },
      select: ({ data }) => data,
      ...options,
    }
  );
}